import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-protect",
  templateUrl: "./med-icon-protect.component.html",
})
export class MedIconProtectComponent extends SvgMixinComponent {}
